import { queryKeyFactory } from "@l2r-front/l2r-query"

export const REPORT_ROOT_QUERY_KEY = "report"

export const reportsQueryKeys = queryKeyFactory(REPORT_ROOT_QUERY_KEY, {
    step: (uuid) => [REPORT_ROOT_QUERY_KEY, "step", uuid] as const,
})
